export const LIST_TYPES = {
    RAW : "raw",
    DAILY : "date",
    MONTHLY : "month"
}

export const FILTERSKEY = {
    PAGINATION : "interviewCredits",
    "START_DATE" : "interviewCreditsStartDate",
    "END_DATE" : "interviewCreditsEndDate",
}